// data
import {
    contentTypeModelTypeSite,
} from 'data'

// serializers
import {
    ContentTypeSettingsTypes,
} from 'serializers/site'

// main
export function getFieldTitleSite({
    column,
    contentType,
    contentTypeSettings,
    profile,
    subContentType,
}: {
    column: string
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    profile: any | undefined
    subContentType: number | undefined
}) {

    const contentTypeSettingsCustom = profile?.settings_data_json?.contentTypeSettingsCustom?.[contentType]

    const newColumn = column.split('__')[0]
    const fieldOptions = contentTypeSettings.field?.[newColumn]
    let valueFieldOptions = undefined
    if (['ManyToManyField', 'ManyToManyRel', 'ManyToOneRel'].includes(contentTypeSettings.field?.[newColumn]?.fieldType)) {
        const valueField = column.split('__')[1] || 'name'
        valueFieldOptions = fieldOptions.fields?.[valueField]
    }
    let subContentTypeSettingsCustom = undefined
    if (subContentType) {
        subContentTypeSettingsCustom = profile?.settings_data_json?.contentTypeSettingsCustom?.[contentType]?.fieldSubContentType?.[subContentType]
    }
    const title = subContentTypeSettingsCustom?.[column]?.verboseName ||
        valueFieldOptions?.verboseName ||
        contentTypeSettingsCustom?.field?.[column]?.verboseNameForList ||
        contentTypeSettingsCustom?.field?.[column]?.verboseName ||
        contentTypeSettings.field?.[column]?.verboseNameForList ||
        contentTypeSettings.field?.[column]?.verboseName
    let relation_field_title = ''
    if (!title && column.split('__')[1]) {
        relation_field_title = profile?.settings_data_json?.contentTypeSettingsCustom?.[`${contentType.split('_')[0]}_${column.split('__')[0]}`]?.field?.[column.split('__')[1]]?.verboseName ||
            contentTypeSettingsCustom?.list?.related_fields_info?.[column]?.verboseName ||
            ''
    }

    return {
        columnTitle: title || column,
        fieldOptions: fieldOptions,
    }
}
